var _style, _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M585 405.6L403.6 559.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M954.4 91.3L539.8 917 430.6 536.3 73 363.6 954.4 91.3m0-64c-1.6 0-3.2.1-4.8.2-5.4.4-10.6 1.5-15.5 3.1l-880 271.8c-25.1 7.8-43 30.1-44.9 56.3-2 26.2 12.3 51 36 62.4L377 581.5l101.3 353.2c7.3 25.3 29.3 43.6 55.6 46.1 2 .2 4 .3 6 .3 24 0 46.2-13.5 57.2-35.3l414-824.5c4.7-8.9 7.4-19.1 7.4-29.9 0-34.1-26.7-62-60.3-63.9-1.3-.2-2.6-.2-3.8-.2zm0 128z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 657.4,
    cy: 344.1,
    r: 32.6,
    fill: "#FFF"
  })));
}

export default SvgSendWhite;